import React from 'react';

const SectionTitle = (props) => {

 return <h2>{props.children}</h2>
};


export default SectionTitle;


// WEBPACK FOOTER //
// ./src/components/Atoms/text/SectionTitle/SectionTitle.js